import React from "react";
import styled from "styled-components";
import { useIntersecting } from "../../../../hooks/useIntersecting";
import BaseSection from "../../BaseSection";
import ScrollOverlayValueCardsFadeIn from "../scrollOverlays/ScrollOverlayValueCardsFadeIn";

interface TeamSection02Props {}

const TeamSection02: React.FC<TeamSection02Props> = () => {
  const { ref } = useIntersecting();

  return (
    <CustomBaseSection ref={ref} fullWidth>
      <ScrollOverlayValueCardsFadeIn />
    </CustomBaseSection>
  );
};

export default TeamSection02;
const CustomBaseSection = styled(BaseSection)``;
